import { getPlatformAppList } from '@/api/menu'
import { whitePages } from '@/const/white'
import { getStore, setStore, clearStore } from '@/util/store'
import { toLogin } from '@/util/util'
import { DialogPlugin } from 'tdesign-vue-next'

const platformId = process.env.VUE_APP_PLATFORM_ID
const platformApps = getStore({ name: 'platformApps' })

const url = new URL(window.location)
if (url.searchParams.has('token')) {
  const token = url.searchParams.get('token')
  const oldtoken = getStore({ name: 'access_token' })
  if (token !== oldtoken) {
    clearStore()
    setStore({
      name: 'access_token',
      content: token,
    })
  }
  url.searchParams.delete('token')
  window.history.replaceState({}, '', url)
}

let DialogInstance = null
window.overtime = () => {
  if (window.JSAndroid) {
    clearStore()
    checkWhite()
  } else {
    if (!DialogInstance) {
      DialogInstance = DialogPlugin.confirm({
        theme: 'warning',
        header: '该帐号登录超时或已在其他设备/浏览器登录，如非本人操作，建议前往帐号信息页面修改密码',
        cancelBtn: null,
        closeBtn: null,
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        confirmBtn: '重新登录',
        onConfirm: () => {
          DialogInstance.destroy()
          clearStore()
          toLogin()
        },
      })
    }
  }
}

const checkWhite = () => {
  const whiteList = ['/generate-paper'].concat(whitePages)
  if (!whiteList.includes(location.pathname)) {
    toLogin()
  }
}

export const getPlatformApps = () => {
  return new Promise((resolve, reject) => {
    if (whitePages.includes(url.pathname)) {
      resolve([])
    }
    if (platformApps && platformApps.length) {
      resolve(platformApps)
    } else {
      getPlatformAppList(platformId)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.code === 0) {
              resolve(res.data.data)
            } else {
              reject(res.data.msg)
            }
          }
        })
        .catch((err) => {
          reject(err)
        })
    }
  })
}
